var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-segments"},[_c('Tag',{staticStyle:{"margin-bottom":"32px"}}),_c('Stage'),_c('Metric')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }